import { createClient } from '@neondatabase/neon-js'

const authUrl = import.meta.env.VITE_NEON_AUTH_URL
const dataApiUrl = import.meta.env.VITE_NEON_DATA_API_URL

if (!authUrl || !dataApiUrl) {
  throw new Error(
    'Missing Neon API configuration: VITE_NEON_AUTH_URL and VITE_NEON_DATA_API_URL are required.',
  )
}

function authAwareFetch(...args: Parameters<typeof fetch>): ReturnType<typeof fetch> {
  return fetch(...args).then((res) => {
    if (res.status === 401) {
      const authToken = localStorage.getItem('token') || sessionStorage.getItem('session_token')
      if (!authToken) return res
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      sessionStorage.removeItem('session_token')
      sessionStorage.removeItem('user')
      window.dispatchEvent(new CustomEvent('auth:expired'))
    }
    return res
  })
}

export const neon = createClient({
  auth: { url: authUrl },
  dataApi: {
    url: dataApiUrl,
    options: {
      db: {
        schema: 'public',
      },
      global: {
        fetch: authAwareFetch,
      },
    },
  },
})
